import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { ProductService } from './sevices/product.service';
import { environment } from '../../environments/environment';
import { CategoryService } from '../header/service/category.service';
import { TreeviewItem, TreeviewConfig } from 'ngx-treeview';
import { SelectedProductService } from '../main-content/sevices/selected-product.service';
import { NotificationService } from '../../app/_services/notification.service';
import { Router } from '@angular/router';
@Component({
  selector: 'app-main-content',
  templateUrl: './main-content.component.html',
  styleUrls: ['./main-content.component.css']
})
export class MainContentComponent implements OnInit {
  public pageId: number = 0;
  @Input() showCategoryFilter: boolean;
  public items: any = [];
  searchText: string = '';
  dropdownEnabled = true;
  newItems: TreeviewItem[] = [];
  categories: any;
  values: number[];
  config = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: false,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    maxHeight: 400
  });
  constructor(private productService: ProductService, private cdr: ChangeDetectorRef, private notifyService: NotificationService, private router: Router, private categoryService: CategoryService, private selectedProductService: SelectedProductService) {
    this.searchText = selectedProductService._searchTextField;
  }

  isListView = false;
  onScroll() {

   // this.pageId = this.pageId + 1;
   // this.getProducts();

  }

 selectedSizes: string[] = [];
  checkboxclass: string = '';

  isFilterChecked(name: string, value: string): void {
    debugger;
    const idx = this.selectedSizes.indexOf(value);

    if (idx > -1) {
      // If size is already selected, remove it
      this.addAttrToFilter('0', name, value);
      this.selectedSizes.splice(idx, 1);
    } else {
      // If size is newly selected, add it
      this.addAttrToFilter('1', name, value);
      this.selectedSizes.push(value);
      this.checkboxclass = "fa fa-check";
    }

    // Update the filter condition based on selected sizes
    this.applySizeFilter();
    
    // Fetch products based on updated filter
  
  }

  // Method to add attributes to the filter (adjust the signature as needed)
  addAttrToFilter(status: string, name: string, value: string): void {
    // Implement the logic to add the attribute to the filter
    console.log(`Added attribute ${name} with value ${value} and status ${status}`);
  }

  // Apply the size filter condition
  applySizeFilter(): void {
    if (this.selectedSizes.length > 0) {
      const sizeFilter = `(${this.selectedSizes.map(size => `'${size}'`).join(',')})`;
      this.filterText = `( [Size] in ${sizeFilter}` + ' ) AND'

    
        this.getProductsAttribute();
      console.log(`Size filter: [Size] IN ${sizeFilter}`);
    } else {
      this.filterText = '';
          this.getProductsAttribute();
      console.log('No size selected');
    }
  }




 navigateToProductDetail(productId: any): void {
   this.router.navigate(['/productdetail'], { queryParams: { productId } });
  }

  updateCart(type, item) {
    if (type == "plus") {
      item.selectedQuantity = item.selectedQuantity + 1;
    } else {
      if (item.selectedQuantity >= 2)
        item.selectedQuantity = item.selectedQuantity - 1;
    }
    this.selectedProductService.items.forEach(element => {
      if (element.id == item.id) {
        element.selectedQuantity = item.selectedQuantity;
      }

    });
    this.selectedProductService.syncItems();
  }

  sizeArray = [];
  filterText = '';
  isProductLoaded = false;
  getProducts() {
    this.productService.getProducts(this.pageId, this.selectedCategories.toString(), this.filterText).subscribe(resp => {

     

   

      if (resp.aaData != undefined || resp.aaData.length > 0) {
        debugger;
        resp?.aaData?.forEach((element, j) => {
          
          let itemToPush = {};
          resp?.aoColumns?.forEach((col, i) => {

            if (!element[13] || !element[12])
          {
         
            element[i] = 'https://dnj.shivamitconsultancy.com/Content/vidya-sury-faith1.gif';
          }

            if (i == 13) {
              var array = element[13].split(',');
              element[i] = environment.globalImagePath + 'ProductImages/'  + array[0];
            }
            // element[i] = environment.globalImagePath + 'ProductImages/' + "Thumb/" + element[13];
            itemToPush[col] = element[i];
          });

          itemToPush["selectedQuantity"] = 1;
          itemToPush["isAddedToCart"] = false;
          console.log(itemToPush);
          this.items.push(itemToPush);
        });
        this.isProductLoaded = true;
     


        this.sizeArray = Array.from(
  new Set(this.items.map(obj => obj.Size))
).map(Size => ({ Size }));

      }
      this.cdr.detectChanges();
    });

    console.log(this.sizeArray)
  }


  getProductsAttribute() {
  
    this.productService.getProducts(this.pageId, this.selectedCategories.toString(), this.filterText).subscribe(resp => {

     
      this.items = [];
   

      if (resp.aaData != undefined || resp.aaData.length > 0) {
        resp?.aaData?.forEach(element => {
          let itemToPush = {};
          resp?.aoColumns?.forEach((col, i) => {
            if (i == 13) {
              var array = element[13].split(',');
              element[i] = environment.globalImagePath + 'ProductImages/'  + array[0];
            }
            // element[i] = environment.globalImagePath + 'ProductImages/' + "Thumb/" + element[13];
            itemToPush[col] = element[i];
          });

          itemToPush["selectedQuantity"] = 1;
          itemToPush["isAddedToCart"] = false;
          console.log(itemToPush);
          this.items.push(itemToPush);
        });

     




      }
      this.cdr.detectChanges();
    });

    console.log(this.sizeArray)
  }


  isLoaded = false;
  ngOnInit(): void {
    debugger;
       const constCategoryId = localStorage.getItem('p_category');
    this.showCategoryFilter = this.showCategoryFilter == undefined ? true : this.showCategoryFilter;
    this.categoryService.getCategories().subscribe(res => {

      res.forEach(element => {
        let currentItem = new TreeviewItem({
          text: element.categoryName,
          value: element.id,
          checked: element.id == constCategoryId ? true : false
        });
        this.newItems.push(currentItem);
        if (element.categories1 != undefined && element.categories1.length > 0) {
          //currentItem.children = [];
          element.categories1.forEach(elementinner => {
            if (currentItem.children == undefined) {
              currentItem.children = [new TreeviewItem({
                text: elementinner.categoryName,
                value: elementinner.id,
                checked: false
              })];
            } else {
              currentItem.children.push(new TreeviewItem({
                text: elementinner.categoryName,
                value: elementinner.id,
                checked: false
              }));
            }
          });
        }

      });
      // this.categories = res;
      this.isLoaded = true;
    });
 


    if (constCategoryId)
    {
      this.selectedCategories.push(constCategoryId);
       localStorage.removeItem('p_category');
    }
    

     this.getProducts();
   
  
  }
  onFilterChange(value: string): void {
    console.log('filter:', value);
  }

  addToCart(currentItem) {
    debugger;
    currentItem.isAddedToCart = true;
    this.selectedProductService.add(currentItem);
    this.notifyService.showSuccess("Add to Card Succcessfully", currentItem.ProductName)
  }
  selectedCategories = [];
  onSelectedChange(value: any): void {

    if (!this.isProductLoaded)
    {
      return;
    }

   
   
    debugger;
    this.pageId = 0;
    this.items = [];
    this.selectedCategories = value;
    // this.isLoaded = false;
    this.productService.getProducts(this.pageId, this.selectedCategories.toString(), this.filterText).subscribe(resp => {
      if (resp.aaData != undefined || resp.aaData.length > 0) {
        resp?.aaData?.forEach(element => {
          let itemToPush = {};
          resp?.aoColumns?.forEach((col, i) => {
            if (i == 13) {
              var array = element[13].split(',');
              element[i] = environment.globalImagePath + 'ProductImages/' + array[0];
            }

            itemToPush[col] = element[i];
          });

          itemToPush["selectedQuantity"] = 1;
          itemToPush["isAddedToCart"] = false;
          console.log(itemToPush);
          this.items.push(itemToPush);
        });
        //this.isLoaded = true;
        this.cdr.detectChanges();
      }

    });
  }

}
